export const MAIN_HEADER = 'mainHeader';
export const LISTING_FILTERS = 'listingFilters';
